import { render } from "./EventCard.vue?vue&type=template&id=b93c1142&scoped=true"
import script from "./EventCard.vue?vue&type=script&lang=js"
export * from "./EventCard.vue?vue&type=script&lang=js"

import "./EventCard.vue?vue&type=style&index=0&id=b93c1142&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-b93c1142"

export default script